'use client'

import { describeLotRecomputeProgress } from '~/app/accounting/lot-recompute'
import { LotRecomputeState } from '~/app/accounting/useLotRecompute'
import { Message } from '~/components/component-library'

export const LotRecomputeBanner = ({
  recompute,
}: {
  recompute: LotRecomputeState
}) => {
  const { job, isRunning, hasPollingFailed, refetch } = recompute

  if (hasPollingFailed) {
    return (
      <Message
        variant="warning"
        action={{ label: 'Check again', onClick: () => refetch() }}
      >
        Unable to load recompute progress
      </Message>
    )
  }

  if (!isRunning || !job) return null

  return (
    <Message variant="info">
      {`${describeLotRecomputeProgress(job)}. Prices, dates, and gains on this page may change when it finishes.`}
    </Message>
  )
}
